import type { Direction } from "../direction";
import type { PointsToDirection } from "../interfaces";
import type { XY } from "../xy";
import { XYEffect } from "./xyEffect";

export class Laser extends XYEffect implements PointsToDirection {
	static key = "Laser";
	private direction: Direction;

	constructor(xy: XY, direction: Direction) {
		super(xy);
		this.direction = direction;
	}

	getDirection(): Direction {
		return this.direction;
	}

	setDirection(dir: Direction): void {
		this.direction = dir;
	}
}
